var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	6890: {
		fallback: () => (__webpack_require__.e(41).then(() => (() => (__webpack_require__(4041))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^18.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",
	},
	1332: {
		fallback: () => (Promise.all([__webpack_require__.e(144), __webpack_require__.e(890)]).then(() => (() => (__webpack_require__(3144))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^18.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",
	},
	5925: {
		fallback: () => (__webpack_require__.e(254).then(() => (() => (__webpack_require__(5873))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^18.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",
	},
	8647: {
		fallback: () => (__webpack_require__.e(466).then(() => (() => (__webpack_require__(1085))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^18.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"261": [
		5925,
		8647
	],
	"332": [
		1332
	],
	"890": [
		6890
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}